<template>
  <NodeViewWrapper class="inline-block relative">
    <div class="inline-block" v-click-outside="stopEditing">
      <div @click="startEditing" class="inline-block bg-gray-100 rounded-md px-1">{{ node.attrs.name }}</div>
      <div class="absolute top-[1.7em] left-0 z-50" v-if="editing">
        <TemplateVariablesDropdownWrapper
          :variables="variables"
          :editor="editor"
          @set-variable="setVariable"
          @stop-editing="stopEditing"
          @add-variable="addVariable"
        />
      </div>
    </div>
  </NodeViewWrapper>
</template>

<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { computed, ref } from 'vue'
import TemplateVariablesDropdownWrapper from '@/questionnaire/components/TemplateVariablesDropdownWrapper.vue'

const props = defineProps({
  ...nodeViewProps,
})

const setVariable = (name: string) => {
  props.updateAttributes({ name })
  stopEditing()
}

const addVariable = () => {
  // Pass the node position so we can update this specific node
  const nodePos = props.getPos()
  props.editor.view.dom.dispatchEvent(
    new CustomEvent('open-template-variable-editor', {
      bubbles: true,
      detail: {
        position: nodePos,
        isNodeView: true, // Flag to indicate this came from a node view
      },
    })
  )
  stopEditing()
}

const startEditing = () => {
  editing.value = true
}
const stopEditing = () => {
  editing.value = false
}

const variables = computed(() => {
  return props.extension.options.templateVariables
})

const editing = ref(false)
</script>
